import { useCallback } from 'react'

import { EMPTY_FUNCTION } from '../../../../constants/common'
import { EmailAttachedThreadsModal } from '../../EmailAttachedThreadsModal'

import {
  getAttachedEmailThreads,
  getEmailThreadsFromResponse,
} from './useEmailAttachedThreadsModalOpener.utils'

export function useEmailAttachedThreadsModalOpener({
  counterTextKey,
  getAttachedFilesProps = EMPTY_FUNCTION,
  headerTextKey,
  loadItems,
  onCloseModal,
  onSetModal,
}) {
  const handleClickEmailTag = useCallback(
    ({ itemId }) => {
      onSetModal(
        <EmailAttachedThreadsModal
          readonly
          attachedFilesProps={getAttachedFilesProps(itemId)}
          counterProps={{
            text: counterTextKey,
          }}
          entityId={itemId}
          getAttachedEmailThreads={getAttachedEmailThreads}
          getItemsFromResponse={getEmailThreadsFromResponse}
          headerProps={{ text: headerTextKey }}
          loadItems={loadItems}
          onClose={onCloseModal}
        />
      )
    },
    [
      counterTextKey,
      getAttachedFilesProps,
      headerTextKey,
      loadItems,
      onCloseModal,
      onSetModal,
    ]
  )

  return { handleClickEmailTag }
}
